// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components-Admin-clientGrid-singleClient-___singleClient__container___Hz0h5","edit-button":"src-components-Admin-clientGrid-singleClient-___singleClient__edit-button___1LZHu"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Admin/clientGrid/singleClient/singleClient.css
// module id = 1054
// module chunks = 0